import { getWorkerPathFromUserType } from "../../utils/utils";
import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";
import {
  TGetWorkerWalletsRequestSchema,
  TGetWorkerWalletsResponseSchema,
} from "./getWorkerWallets.schema";

export const getWorkerWallets = (axios: IAxiosInstance) => {
  return async (data: TGetWorkerWalletsRequestSchema) => {
    const { worker_id, worker_type, ...rest } = data;

    const workerTypePath = getWorkerPathFromUserType(worker_type);

    const response = await axios.noRetry.get<
      IApiResponse<TGetWorkerWalletsResponseSchema>
    >(`/api/${workerTypePath}/${worker_id}/wallets`, { params: rest });

    return response.data;
  };
};
